class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    this.add = this.querySelector("[data-plus");
    this.subtract = this.querySelector("[data-minus");
    this.input = this.querySelector("input");
    this.key = this.dataset.key;
  }

  connectedCallback() {
    this.add.addEventListener("click", this.increment.bind(this));
    this.subtract.addEventListener("click", this.decrement.bind(this));
  }

  increment() {
    this.input.value = parseInt(this.input.value) + 1;
    this.input.dispatchEvent(
      new CustomEvent("quantity-selector:update", {
        bubbles: true,
        detail: {
          key: this.key,
          quantity: this.input.value,
        },
      }),
    );
  }

  decrement() {
    if (parseInt(this.input.value) > 0) {
      this.input.value = parseInt(this.input.value) - 1;
      this.input.dispatchEvent(
        new CustomEvent("quantity-selector:update", {
          bubbles: true,
          detail: {
            key: this.key,
            quantity: this.input.value,
          },
        }),
      );
    }
  }
}

if (!customElements.get("quantity-selector")) {
  customElements.define("quantity-selector", QuantitySelector);
}
